import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'

import Card from '@/components/Card'
import PaginationTable from '@/components/PaginationTable'

import columns from './columns'
import messages from './messages'

import './index.scss'

const NotificationSources = ({
  notificationSources,
  startIndex,
  isActionInProgress,
  onDelete,
  onEdit,
  perPage
}: any) => {
  const intl = useIntl()

  return (
    <Card isActionInProgress={isActionInProgress}>
      <Card.Header title={<FormattedMessage {...messages.existingNotificationSources} />} />
      <PaginationTable
        columns={columns({
          intl,
          onDelete: onDelete,
          onEdit: onEdit
        })}
        pagination={{
          count: notificationSources.length,
          startIndex: startIndex,
          perPage: perPage
        }}
        rows={notificationSources}
        rowItemType={<FormattedMessage {...messages.notificationSources} />}
        rowKey="id"
      />
    </Card>
  )
}

NotificationSources.displayName = 'NotificationSources'

NotificationSources.propTypes = {
  isActionInProgress: PropTypes.bool.isRequired,
  notificationSources: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  spaceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  startIndex: PropTypes.number.isRequired
}

export default NotificationSources
